import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface FocusArea {
  id: string;
  name: string;
}

interface FocusAreaSelectorProps {
  focusAreas?: FocusArea[];
  selectedFocusAreas: string[];
  search: string;
  onSearchChange: (value: string) => void;
  onToggle: (id: string, checked: boolean) => void;
}

export const FocusAreaSelector = ({
  focusAreas,
  selectedFocusAreas,
  search,
  onSearchChange,
  onToggle,
}: FocusAreaSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label>Focus Areas</Label>
      <Input
        placeholder="Search focus areas..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <div className="grid grid-cols-2 gap-2 max-h-32 overflow-y-auto border rounded-md p-3">
        {(focusAreas || [])
          .filter((fa) => fa.name.toLowerCase().includes(search.toLowerCase()))
          .map((focusArea) => (
            <div key={focusArea.id} className="flex items-center space-x-2">
              <Checkbox
                id={focusArea.id}
                checked={selectedFocusAreas.includes(focusArea.id)}
                onCheckedChange={(checked) => onToggle(focusArea.id, Boolean(checked))}
              />
              <Label htmlFor={focusArea.id} className="text-sm">
                {focusArea.name}
              </Label>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FocusAreaSelector;

